<!--
 * @Author: 天天抽奖
 * @Date: 2020-07-28 12:04:26
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 15:23:01
 * @FilePath: \car-demo\src\views\LuckyDraw.vue
-->
<template>
	<div class="lucky-draw">
        <FixedTool />

		<a href="javascript:;" class="my-gift"  @click="$router.push({ path: '/my-gift' })"
		><img src="../assets/images/lipin.png" alt="" /> 我的奖品</a>

		<div class="draw-area">
			<vue-baberrage
					:isShow="barrageIsShow"
					:barrageList="barrageList"
					:loop="true"
			>
			</vue-baberrage>
			<div class="luckdraw-bg">
				<nut-luckdraw
					class="drawTable"
					ref="luckDrawPrize"
					:luck-width="luckWidth"
					:luck-height="luckheight"
					:prize-list="prizeList"
					:turns-number="turnsNumber"
					:turns-time="turnsTime"
					:prize-index="prizeIndex"
					:style-opt="styleOpt"
					@end-turns="endTurns"
					>
					<template slot="item" slot-scope="scope">
						<div class="drawTable-name">{{ scope.item.prizeName }}</div>
					</template>
				</nut-luckdraw>
			</div>
			
			<div @click="startTurns1" class="pointer" :style="pointerStyle" style="top: 45%;">
				<img src="../assets/images/lucky-text.png" alt="">
			</div>
		</div>

		<div class="gift-list" style="margin-top: 40px;">
			<p class="title">奖品</p>
			<ul>
				<li class="gift-list-item" v-for="(item, index) in prize_info.prizelist" :key="index">
					<img
							:src ="item.pic"
							onerror="this.src='https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2588111137,2818876915&fm=26&gp=0.jpg'"
							class="picture"
					/>
					<ul class="detail">
						<li class="name">{{item.grade}}:{{item.prizename}}</li>
						<li class="price">价值：{{item.worth}}元</li>
						<li class="desc">
							<span>提供商家：{{item.store_name.length >= 10 ? item.store_name.slice(0,10) + '...' : item.store_name}}</span>
							<span v-if="prize_info.info.showawardcount == '1' ">数量：{{item.prizecount}}</span>
						</li>
					</ul>
				</li>
			</ul>
		</div>

		<div class="rules">
			<b class="title"><template v-if="this.$ajax.is_activity()">活动规则</template><template v-else>平台规则</template></b>
			<div class="role_content" v-html="prize_info.info.wheelrule">
			</div>
		</div>
	</div>
</template>

<script>
    import { MESSAGE_TYPE } from 'vue-baberrage'

    var msg = ''
    export default {
        data() {
            return {
                // 弹幕
                msg: 'Hello World',
                barrageIsShow: true,
                currentId: 0,
                barrageList: [],
                prize_info: {
                    info:{
                        wheelrule:'',
                        showawardcount:'0',
                    },

                } ,
                // 转盘大小
                luckWidth: '290px',
                luckheight: '290px',
                // 转盘指针图片样式
                pointerStyle: {
                    width: '80px',
                    height: '80px',
                    backgroundImage:
                        'url("http://r.imgccoo.cn/zycadmin/images/lucky-zhiz.png")',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                },
                // 奖品列表
                prizeList: [
                    {
                        id: 'thanks',
                        prizeName: '谢谢惠顾',
                    },
                    {
                        id: 'one',
                        prizeName: '一等奖',
                    },
                    {
                        id: 'two',
                        prizeName: '二等奖',
                    },
                    {
                        id: 'three',
                        prizeName: '三等奖',
                    },
                    {
                        id: 'four',
                        prizeName: '四等奖',
                    },
                    {
                        id: 'five',
                        prizeName: '五等奖',
                    },
                    {
                        id: 'six',
                        prizeName: '六等奖',
                    },
                    {
                        id: 'thanks',
                        prizeName: '谢谢惠顾',
                    },
                ],

                turnsNumber: 5, // 转动圈数
                turnsTime: 5, // 转动时间：S
                styleOpt: {
                    prizeBgColors: [
                        'rgb(255, 231, 149)',
                        'rgb(255, 247, 223)',
                        'rgb(255, 231, 149)',
                        'rgb(255, 247, 223)',
                        'rgb(255, 231, 149)',
                        'rgb(255, 247, 223)',
                        'rgb(255, 231, 149)',
                        'rgb(255, 247, 223)',
                    ],
                    borderColor: 'transparent',
                },
                prizeIndex: -1, // 中奖奖品的index
                lock: false, // 防止多次连续点击抽奖
                num: 3, // 抽奖次数,根据需求定义
            }
        },
        mounted() {
            this.get_locuk_info();//获取抽奖信息
          //  this.addToList()
        },
        methods: {
            get_locuk_info(){
                var id = this.$ajax.get_activity_id()

                //用户信息接口
                this.$ajax
                    .get('/m/activebigwheel/index?activity_id=' + id, {})
                    .then((res) => {
                        this.prize_info = res
                        this.barrageList =res.win
						this.shareDiyRead(res.info);
                    })},


                startTurns1() {
                var id = this.$ajax.get_activity_id()

                //用户信息接口
                this.$ajax
                    .get('/m/activebigwheel/GetLottey?activity_id=' + id, {})
                    .then((res) => {
                        msg = res.msg
                        this.startTurns(res.num)
                    })
            },
            startTurns(num) {
                var index = 1
                index = num

				var can_wheel = parseInt(this.prize_info.can_wheel);
				if(can_wheel !== 1){
					this.$toast.text(this.prize_info.can_wheel_text);return false;
				}
                // if (!this.canBeRotated()) {
                // 	return false
                // }

                // 成功后抽奖次数减1

                // 中奖奖品的index
                this.prizeIndex = index
                // 调用组件的方法，使转盘转动并停留在中奖奖品的那个扇形区域
				this.$refs.luckDrawPrize.rotate(index)
            },
            endTurns() {
                this.$dialog({
                    content: msg,
                    noCloseBtn: false,
                    noOkBtn: true,
                    cancelBtnTxt: '我知道了',
                })
                this.lock = false
            },
			shareDiyRead(data){
            	if(parseInt(data.state) == 1){
            		//抽奖进行中
					if(data.simg_start){
						window.shareConf.fx_pic = data.simg_start;
					}
					if(data.stitle_start){
						window.shareConf.fx_title = data.stitle_start;
					}
					if(data.sdesc_start){
						window.shareConf.fx_memo = data.sdesc_start
					}
				}else{
            		//抽奖结束
					if(data.simg_end){
						window.shareConf.fx_pic = data.simg_end;
					}
					if(data.stitle_end){
						window.shareConf.fx_title = data.stitle_end;
					}
					if(data.sdesc_end){
						window.shareConf.fx_memo = data.sdesc_end
					}
				}

				window.shareConf.fx_url = data.url;
				shareDiy();
			}
        },
    }
</script>

<style lang="less" scoped>
.nut-dialog-content {
	color:#fff;
}
	.role_content{
		::v-deep{
			img{width: 100%;}
		}
	}
	.lucky-draw {
		width: 100%;
		// overflow-x: hidden;
		background-color: rgba(255, 68, 25, 1);
		background-image: url(../assets/images/lucky-draw-bg.png);
		background-repeat: no-repeat;
		padding-bottom: 20px;
		background-size: 102%;
	}

	.my-gift {
		position: fixed;
		right: 14px;
		top: 10px;
		z-index: 99;
		display: flex;
		align-items: center;
		font-size: 12px;
		background-color: rgba(255, 255, 255, 0.2);
		padding: 3px 6px;
		border-radius: 10px;
		color: #fff;
		img {
			margin-right: 4px;
		}
	}
	// 转盘区域
	.draw-area {
		position: relative;
		height: 469px;
	}
	.drawTable {
		overflow: hidden;
		bottom: 0;
	}
	.drawTable-name {
		width: 1em;
		left: 50%;
		margin-left: -0.5em;
		color: #ff3d00;
		font-size: 15px;
		font-weight: bold;
	}

	.luckdraw-bg {
		width: 334px;
		height: 334px;
		position: absolute;
	    left: 50%;
	    top: 45%;
	    transform: translate(-50%,-50%);
	    text-align: center;
	    background-image: url(../assets/images/lucky-draw-bg1.png);
	}

	// 礼品列表
	.gift-list {
		padding: 0 14px;
		.title {
			text-align: center;
			padding: 0 0 15px 0;
			font-size: 15px;
			color: #fff;
			font-weight: bold;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);
		}
		&-item {
			display: flex;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);
			padding: 10px 0;
			.picture {
				width: 100px;
				height: 75px;
				border-radius: 3px;
				margin-right: 10px;
			}
			.detail {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				flex-grow: 1;
				height: 75px;
				.name {
					font-size: 15px;
					font-weight: bold;
					color: #ffffff;
				}
				.price {
					font-size: 15px;
					color: rgba(255, 255, 255, 0.8);
				}
				.desc {
					display: flex;
					justify-content: space-between;
					font-size: 11px;
					color: rgba(255, 255, 255, 0.6);
				}
			}
		}
	}
	// 规则说明
	.rules {
		min-height: 187px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin: 20px 14px 0 14px;
		padding: 10px;
		font-size: 13px;
		color: #666666;
		line-height: 20px;
		.title {
			display: block;
			color: #333333;
			font-size: 15px;
			padding-bottom: 10px;
			text-align: center;
		}
	}

	// 弹幕样式
	/deep/ .baberrage-stage {
		z-index: 98;
	}
	/deep/ .baberrage-lane .baberrage-item .normal {
		font-size: 12px;
		background: rgba(0, 0, 0, 0.4);
		// height: 24px;
		// line-height: 24px;
		position: absolute;
		z-index: 99;
	}

	.pointer {
		position: absolute;
		z-index: 99;
	}
	.pointer img {
		position: absolute;
		left: 20%;
	    top: 30%;
	}
</style>
